import { render } from "./WarehouseReportPage.vue?vue&type=template&id=6006f499&scoped=true&ts=true"
import script from "./WarehouseReportPage.vue?vue&type=script&lang=ts"
export * from "./WarehouseReportPage.vue?vue&type=script&lang=ts"

import "./WarehouseReportPage.vue?vue&type=style&index=0&id=6006f499&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6006f499"]])

export default __exports__